import React, { useEffect, useRef, useState } from 'react';
import Livestream from "./components/Livestream";
import Previews from "./components/Previews";
import { init as initGA, event } from "../Helpers/ga";

initGA();

let CHANNELS = [
  { name: 'TPT2', requiresDMA: false },
  { name: 'TPTKIDS', requiresDMA: false },
  { name: 'TPTNOW', requiresDMA: false }
];

function time() {
  return Math.floor(Date.now() / 1000);
}

function usePageDurationTracking(channel) {
  let timedChannel = useRef(channel);
  let startTime = useRef(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      let channelName = CHANNELS[timedChannel.current].name;
      let now = time();

      if (startTime.current) {
        event('Livestream', 'Time On Channel', channelName, now - startTime.current);
      }

      timedChannel.current = channel;
      channelName = CHANNELS[timedChannel.current].name;
      startTime.current = now;

      function onLeave() {
        event('Livestream', 'Time On Channel', channelName, time() - startTime.current);
      }

      window.addEventListener('beforeunload', onLeave);

      return () => {
        window.removeEventListener('beforeunload', onLeave);
      }
    }
  }, [channel]);
}

export default function App({ previews }) {
  let [channel, setChannel] = useState(0);
  let { name, requiresDMA } = CHANNELS[channel];
  usePageDurationTracking(channel);

  return <div>
    <Livestream channel={name} requiresDMA={requiresDMA} />
    <Previews channels={CHANNELS} current={channel} previews={previews} onClickPreview={channelIndex => {
      const selectedChannel = CHANNELS[channelIndex]; // Get the channel info based on index
      if (selectedChannel.name === 'TPTKIDS') {
        // If the channel is 'TPTKIDS', redirect to the specific URL
         window.open('https://pbskids.org/videos/watch/live', '_blank');
      } else {
        // For other channels, perform the original behavior
        window.scrollTo(0, 0);
        setChannel(channelIndex);
      }
    }} />
  </div>;
}
